import { render, staticRenderFns } from "./ValveNBUpInstructions2.vue?vue&type=template&id=27a7a436&"
import script from "./ValveNBUpInstructions2.vue?vue&type=script&lang=js&"
export * from "./ValveNBUpInstructions2.vue?vue&type=script&lang=js&"
import style0 from "./ValveNBUpInstructions2.vue?vue&type=style&index=0&id=27a7a436&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports